import type { GetPartnerIntegrationStatusPayload } from "../../slices/integration-status/Types";

export const integrationStatusSagaActionTypes = {
  callGetPartnerIntegrationStatusSaga:
    "callGetPartnerIntegrationStatusSaga",
  callExportPartnerIntegrationStatusSaga:
    "callExportPartnerIntegrationStatusSaga",
};

export const getPartnerIntegrationStatusSagaAction = (
  payload: GetPartnerIntegrationStatusPayload
) => ({
  type: integrationStatusSagaActionTypes.callGetPartnerIntegrationStatusSaga,
  payload,
});

export const exportPartnerIntegrationStatusSagaAction = (
  payload: GetPartnerIntegrationStatusPayload
) => ({
  type: integrationStatusSagaActionTypes.callExportPartnerIntegrationStatusSaga,
  payload,
});
